import { useExamStore } from "@store"
import { ExamQuestionType } from "@types"
import { SingleChoiceOption } from "./options/SingleChoiceOption"
import { MultipleChoiceOption } from "./options/MultipleChoiceOption"
import { ImageOption } from "./options/ImageOption"
import { CorrectIncorrectOption } from "./options/CorrectIncorrectOption"
import { EssayOption } from "./options/EssayOption"
import { ConnectingOption } from "./options/ConnectingOption"
import { ShortAnswerOption } from "./options/ShortAnswerOptions"
import { MultipleImageOption } from "./options/MultipleImageOptions"


export const chooseQuestionTypeLayout = () => {
    const clickedQuestion = useExamStore.getState().clickedQuestion
    
    if (clickedQuestion?.questionType.id === ExamQuestionType.SingleChoice) {
        return <SingleChoiceOption key={"single"}/>
    } else if (clickedQuestion?.questionType.id === ExamQuestionType.MultipleChoices) {
        return <MultipleChoiceOption key={"multiple"}/>
    } else if (clickedQuestion?.questionType.id === ExamQuestionType.ImageChoice) {
        return <ImageOption key={"image"}/>
    } else if (clickedQuestion?.questionType.id === ExamQuestionType.CorrectIncorrect) {
        return <CorrectIncorrectOption key={"correct"}/>
    } else if (clickedQuestion?.questionType.id === ExamQuestionType.EssayQuestion) {
        return <EssayOption key={"essay"}/>
    } else if (clickedQuestion?.questionType.id === ExamQuestionType.Connecting) {
        return <ConnectingOption key={"connecting"}/>
    } else if (clickedQuestion?.questionType.id === ExamQuestionType.ShortAnswer) {
        return <ShortAnswerOption key={"short"}/>
    } else if (clickedQuestion?.questionType.id === ExamQuestionType.ImageMultipleChoice) {
        return <MultipleImageOption key={"multipleImage"}/>
    }
}
